import React from 'react';
import styles from './FeatureIcon.module.css';

/**
 * FeatureIcon   tinted rounded square containing an icon.
 * tint: 'purple' | 'cyan' | 'blue' | 'pink' | 'dark' | 'soft'
 * size: 'sm' | 'md' | 'lg'
 */
const FeatureIcon = ({ icon: Icon, tint = 'purple', size = 'md', className = '' }) => {
  return (
    <span className={`${styles.box} ${styles[tint]} ${styles[size]} ${className}`}>
      <Icon aria-hidden="true" />
    </span>
  );
};

export default FeatureIcon;
